import React, { Component } from 'react'
import PropTypes            from 'prop-types'

class ProfessionItem extends Component {

  static propTypes = {
    history: PropTypes.object,
    major: PropTypes.object,
    onClick: PropTypes.func,
  }

  handleClick(major) {
    const { id } = major
    const { history, onClick } = this.props
    history.push(`/profession/detail/${id}`)
    typeof onClick === 'function' && onClick(id)
  }

  render() {
    const { major } = this.props
    return (
      <div className="major-item" onClick={this.handleClick.bind(this, major)}>
        <span>{major.name}</span>
        <svg className="icon icon-indicator_3">
          <use xlinkHref="#icon-indicator_3"></use>
        </svg>
      </div>
    )
  }
}

ProfessionItem.defaulProps = {
  history: {
    push: () => {
    }
  },
  major: {},
  onClick: () => {
  },
}

export default ProfessionItem


// WEBPACK FOOTER //
// ./src/pages/Profession/List/ProfessionItem.js